// extracted by mini-css-extract-plugin
export default {"projectHolders":"SelectProjectPage_projectHolders__q-7yF"};